<template>
    <div class="carousel-control">
        <button :disabled="slideCount < 2" class="carousel-control__prev slider-arrow slider-arrow--prev" aria-label="Previous" @click="prev" >Previous</button>
        <div class="carousel-control__pips slider-pips" v-if="pipsCount > 1">
            <div v-for="index in pipsCount"
                :key="index" class="slider-pips__item"
                :class="{ 'slider-pips__item--active': (index - 1) === currentSlideIndex }"
                :aria-label="`Slide ${index}`"
                :aria-current="(index - 1) === currentSlideIndex"
                :aria-controls="`slide-${index}`"></div>
        </div>
        <button :disabled="slideCount < 2" class="carousel-control__next slider-arrow slider-arrow--next" aria-label="Next" @click="next">Next</button>
    </div>
</template>
<script setup>
import { computed } from 'vue';

// The current slide index
const currentSlideIndex = defineModel('currentSlideIndex');

const props = defineProps({
    // The number of slides
    slideCount: {
        type: Number,
        required: true
    },
    maxPips: {
        type: Number,
        default: 10
    }
});

const pipsCount = computed(() => Math.min(props.slideCount, props.maxPips));

/**
 * Move to the next slide
 */
const next = () => {
    currentSlideIndex.value = (currentSlideIndex.value + 1) % props.slideCount;
};

/**
 * Move to the previous slide
 */
const prev = () => {
    currentSlideIndex.value = (currentSlideIndex.value - 1 + props.slideCount) % props.slideCount;
};
</script>